import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { usePostHog } from 'posthog-js/react'
import { useCallback, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRouteError } from 'react-router-dom'
import { removeRxDatabase, RxError } from 'rxdb'

import AccordionSection from '@/modules/assessments/components/Summary/components/AccordionSection.tsx'
import { databaseName, storage } from '@/system/rxdb/setup.ts'

import messages from './messages'

const sxButton = { marginTop: 2 }

const Pre = styled('pre')(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
  whiteSpace: 'pre-wrap',
}))

export const ErrorHandler = () => {
  const error = useRouteError()
  const { formatMessage } = useIntl()
  const posthog = usePostHog()
  const onResetButtonClick = useCallback(async () => {
    location.replace('/')
  }, [])

  useEffect(() => {
    posthog?.captureException(error)
  }, [error, posthog])

  const onResetDatabaseClick = useCallback(async () => {
    const thisDbName =
      error instanceof RxError ? error.parameters.database : databaseName
    try {
      await removeRxDatabase(thisDbName, storage)
    } catch (e) {
      console.error(e)
    }
    location.replace('/')
  }, [error])

  const isDbError = error instanceof RxError

  return (
    <Container>
      <Typography gutterBottom component="h1" variant="h2">
        {formatMessage(messages.errorTitle)}
      </Typography>
      {isDbError && (
        <Typography variant="subtitle2">
          {formatMessage(messages.databaseError, { code: error.code })}
        </Typography>
      )}
      {!isDbError && error instanceof Error && (
        <Typography variant="body1">{error.message}</Typography>
      )}
      <br />
      {error instanceof Error ? (
        <div>
          <AccordionSection
            noPadding
            title={formatMessage(messages.errorDetails)}
          >
            <Pre>{error.stack || error.message}</Pre>
          </AccordionSection>
        </div>
      ) : null}
      <Stack sx={sxButton} gap={1.5} direction="row">
        <Button
          color={isDbError ? 'error' : 'secondary'}
          onClick={isDbError ? onResetDatabaseClick : onResetButtonClick}
        >
          {isDbError
            ? formatMessage(messages.resetAppButton)
            : formatMessage(messages.reloadApp)}
        </Button>
        {!isDbError && (
          <Button color="error" onClick={onResetDatabaseClick}>
            {formatMessage(messages.resetAppButton)}
          </Button>
        )}
      </Stack>
    </Container>
  )
}
